import { render, staticRenderFns } from "./EditPositions.vue?vue&type=template&id=0dad2a65"
import script from "./EditPositions.vue?vue&type=script&lang=ts"
export * from "./EditPositions.vue?vue&type=script&lang=ts"
import style0 from "./EditPositions.vue?vue&type=style&index=0&id=0dad2a65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports